import React, { forwardRef } from "react";

export interface LeftChevronProps
  extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  variant?: "outline" | "filled";
  title?: string | null;
}

const LeftChevron = forwardRef<SVGSVGElement, LeftChevronProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 2,
      variant = "outline",
      title = "Chevron left",
      ...props
    },
    ref
  ) => {
    const ariaProps = title
      ? { role: "img", "aria-label": title }
      : { "aria-hidden": true };

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={variant === "filled" ? color : "none"}
        xmlns="http://www.w3.org/2000/svg"
        {...ariaProps}
        {...props}
      >
        {variant === "outline" ? (
          <path
            d="M15.41 7.41L10.83 12l4.58 4.59"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ) : (
          <path
            d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
            fill={color}
          />
        )}
      </svg>
    );
  }
);

LeftChevron.displayName = "LeftChevron";

export default LeftChevron;
